export class ShowMoveUserLogoutAlertEvent {
}

export class ShowMoveUserTransferredAlertEvent {
}